import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Footer from '@/components/Footer';
import { Reveal, MaskedLine, MaskedLineInView } from '@/components/Reveal';
import { MANIFESTO } from '@/data/products';
import { useProducts } from '@/lib/shopify';

export default function Story() {
  const { products } = useProducts();
  const storyProduct = products[1] || products[0];
  return (
    <div className="aura-page-surface relative min-h-screen text-[#1E1E1E]" data-testid="story-page">
      <div className="mx-auto max-w-7xl px-6 pt-36 md:px-10 md:pt-44">
        <p className="font-mono2 text-[10px] uppercase tracking-[0.4em] text-[#777]">
          Our Story — Started after midnight
        </p>
        <h1 className="mt-4 font-syne text-4xl font-extrabold uppercase leading-[0.9] sm:text-5xl lg:text-6xl" data-testid="story-title">
          <MaskedLine delay={0.1}>Made for</MaskedLine>
          <MaskedLine delay={0.2}>
            <span className="steel-text">being seen.</span>
          </MaskedLine>
        </h1>

        <div className="mt-20 grid items-start gap-14 md:grid-cols-12">
          <Reveal className="md:col-span-7">
            <div className="overflow-hidden bg-[#F0F1EE]">
              {storyProduct &&
              <img
                src={storyProduct.image}
                alt={storyProduct.name}
                className="aspect-[16/10] w-full object-contain transition-transform duration-700 hover:scale-105"
                data-testid="story-shopify-image"
              />
              }
            </div>
            <p className="mt-4 font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#777]">
              Archive — the first rack, 2019
            </p>
          </Reveal>
          <div className="md:col-span-5">
            <Reveal delay={0.15}>
              <p className="text-lg font-light leading-relaxed text-[#333]">
                Aura Studio 98 started with screen-printed tees made for friends, DJs, and the people
                still dancing when the lights came on.
              </p>
              <p className="mt-6 text-base font-light leading-relaxed text-[#5C5C5C]">
                Today we make limited runs between Seoul and Milan. Every drop has its own mood,
                every piece is built to become part of somebody else's story.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-32 space-y-28 pb-32">
          {MANIFESTO.map((c, i) => (
            <div key={c.n} className="grid items-center gap-10 md:grid-cols-12" data-testid={`story-chapter-${c.n}`}>
              <div className={`md:col-span-5 ${i % 2 ? 'md:order-2' : ''}`}>
                <Reveal>
                  <span className="sage-text font-mono2 text-7xl font-bold md:text-8xl">{c.n}</span>
                </Reveal>
                <h2 className="mt-4 font-syne text-4xl font-extrabold uppercase tracking-tight md:text-5xl">
                  <MaskedLineInView>{c.title}</MaskedLineInView>
                </h2>
              </div>
              <Reveal delay={0.15} className={`md:col-span-6 ${i % 2 ? 'md:order-1 md:col-start-1' : 'md:col-start-7'}`}>
                <p className="border-l border-[#C7CCC5] pl-8 text-base font-light leading-relaxed text-[#5C5C5C]">
                  {c.body}
                </p>
              </Reveal>
            </div>
          ))}
        </div>

        <Reveal className="pb-32 text-center">
          <p className="font-mono2 text-[10px] uppercase tracking-[0.4em] text-[#777]">
            Chapter 04 is being written
          </p>
          <Link
            to="/shop"
            data-testid="story-shop-cta"
            className="group mt-8 inline-flex items-center gap-3 bg-[#1E1E1E] px-10 py-5 font-syne text-xs font-bold uppercase tracking-[0.16em] text-white transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-[#657260]"
          >
            Shop the current drop
            <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
      <Footer />
    </div>
  );
}
